import script from "./StatsImpacts.vue?vue&type=script&lang=js"
export * from "./StatsImpacts.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__